import { LocalStorageKeys } from '../../../../enums/local-storage-keys';
import { getFromLocalStorage } from '../../../../utils';

export interface PatientDoctorFormData {
  doctorId: number;
}

export interface PatientRegistrationFormData {
  memberId: number;
  email: string;
  password: string;
  passwordConfirm: string;
}

export interface PatientPrescriptionFormData {
  leftEye: string;
  rightEye: string;
}

export interface PatientPlanFormData {
  subscriptionType: string;
  productType: string;
  frequency: string;
}

export interface PatientAddressFormData {
  matchAddress: boolean;
  billingAddress: {
    firstName: string;
    lastName: string;
    company: string | undefined;
    line1: string;
    line2: string | undefined;
    city: string;
    state: string;
    postalCode: string;
    country: string;
    phone: string;
  };
  shippingAddress: {
    firstName: string;
    lastName: string;
    company: string | undefined;
    line1: string;
    line2: string | undefined;
    city: string;
    state: string;
    postalCode: string;
    country: string;
    phone: string;
  };
}

export interface PatientFormData {
  doctor: PatientDoctorFormData;
  registration: PatientRegistrationFormData;
  prescription: PatientPrescriptionFormData;
  plan: PatientPlanFormData;
  address: PatientAddressFormData;
}

export interface PatientPageState {
  completedDoctor: boolean;
  completedRegistration: boolean;
  completedPrescription: boolean;
  completedPlan: boolean;
  completedShipping: boolean;
  completedBilling: boolean;
  completedPayment: boolean;
  completedForm: boolean;
  openDoctor: boolean;
  openRegistration: boolean;
  openPrescription: boolean;
  openPlan: boolean;
  openLogin: boolean;
  openShipping: boolean;
  openBilling: boolean;
  openSummary: boolean;
  openPayment: boolean;
  validDoctor: boolean;
  validRegistration: boolean;
  validPrescription: boolean;
  validPlan: boolean;
  validShipping: boolean;
  validBilling: boolean;
  validPayment: boolean;
  validForm: boolean;
}

export interface PatientState {
  formData: PatientFormData;
  pageState: PatientPageState;
}

export const fallbackPatientState: PatientState = {
  formData: {
    doctor: {
      doctorId: 0,
    },
    registration: {
      memberId: 0,
      email: '',
      password: '',
      passwordConfirm: '',
    },
    prescription: {
      leftEye: '',
      rightEye: '',
    },
    plan: {
      subscriptionType: '',
      productType: '',
      frequency: '',
    },
    address: {
      matchAddress: true,
      billingAddress: {
        firstName: '',
        lastName: '',
        company: '',
        line1: '',
        line2: '',
        city: '',
        state: '',
        postalCode: '',
        country: '',
        phone: '',
      },
      shippingAddress: {
        firstName: '',
        lastName: '',
        company: '',
        line1: '',
        line2: '',
        city: '',
        state: '',
        postalCode: '',
        country: '',
        phone: '',
      },
    },
  },
  pageState: {
    completedDoctor: false,
    completedRegistration: false,
    completedPrescription: false,
    completedPlan: false,
    completedShipping: false,
    completedBilling: false,
    completedPayment: false,
    completedForm: false,
    openDoctor: true,
    openRegistration: false,
    openPrescription: false,
    openPlan: false,
    openLogin: false,
    openShipping: false,
    openBilling: false,
    openSummary: false,
    openPayment: false,
    validDoctor: false,
    validRegistration: false,
    validPrescription: false,
    validPlan: false,
    validShipping: false,
    validBilling: false,
    validPayment: false,
    validForm: false,
  },
};

export const initialPatientState: PatientState = getFromLocalStorage(
  LocalStorageKeys.PATIENT_STATE,
  fallbackPatientState
);
